<template>
	<div class="row" v-if="data != null">
		<resumo :data="data.statusContrato" />

		<div class="col-sm-12 col-lg-6">
			<box title="Situação dos Exames" id="situacao-dos-contratos">
				<template slot="body">
					<novos-contratos
						:data="data.statusContrato"
						:totalPropostas="data.totalPropostas"
					/>
				</template>
			</box>
		</div>

		<div class="col-sm-12 col-lg-6">
			<box title="Exames por Navio" id="contratos-por-regiao">
				<template slot="tools">
					<btn-status-stack v-model="navio" />
				</template>
				<template slot="body">
					<navios
						ref="navios"
						:data="data.navios"
						:navios="data.navios"
						:type="navio"
					/>
				</template>
			</box>
		</div>

		<div class="col-sm-12">
			<box title="Exames por Local">
				<template slot="body">
					<contratos-por-regiao :data="data.contratosPorRegiao" />
				</template>
			</box>
		</div>

		<!--
      <div class="col-sm-12">
      <box title='Exames por Local De Coleta'>
        <template slot='tools'>
          <btn-status v-model='statusOs'/>
        </template>
        <template slot='body'>
          <ordem-de-servico ref='ordemDeServico'
            :data='data.statusDasTarefas'
            :type='statusOs'
          />
        </template>
      </box>
      </div>
    --></div>
	<div v-else>carregando</div>
</template>
<script>
	import WBS from 'js/http';
	import box from 'box';
	import NovosContratos from './components/contatos.vue';
	import ContratosPorRegiao from './components/contratos-por-regiao.vue';
	import OrdemDeServico from './components/ordem-de-servico.vue';
	import navios from './components/navios.vue';
	import BtnStatus from './components/btn-status.vue';
	import BtnStatusStack from './components/btn-status-stack.vue';
	import Resumo from './components/resumo.vue';

	export default {
		name: 'SistemDash',
		components: {
			Resumo,
			NovosContratos,
			ContratosPorRegiao,
			OrdemDeServico,
			navios,
			BtnStatus,
			BtnStatusStack,
			box,
		},
		data() {
			return {
				data: null,
				statusOs: 'novas', // finalizadas atraso
				navio: 'todos',
				navios: [],
			};
		},
		provide() {
			function getUltimos12Meses() {
				const meses = [
					'',
					'Jan',
					'Fev',
					'Mar',
					'Abr',
					'Mai',
					'Jun',
					'Jul',
					'Ago',
					'Set',
					'Out',
					'Nov',
					'Dez',
				];
				let periodo = [];
				for (let x = 11; x >= 0; x--) {
					let date = new Date();
					date.setMonth(date.getMonth() - x);

					let month =
						date.getMonth() + 1 <= 9
							? `0${date.getMonth() + 1}`
							: date.getMonth() + 1;

					periodo.push({
						date: `${date.getFullYear()}-${month}`,
						xDate: `${
							meses[parseInt(month)]
						}/${date.getFullYear()}`,
					});
				}
				return periodo;
			}

			return {
				vigencia: getUltimos12Meses(),
				mapVigencia(vigencia, data, findCmp, resp) {
					return vigencia.reduce((acc, item) => {
						let rfData = data.find(
							(fItem) => fItem[findCmp] == item.date
						);
						acc.push(rfData == null ? 0 : rfData[resp]);
						return acc;
					}, []);
				},
			};
		},

		mounted() {
			WBS.send('protected-read-appExamsDashboard', (resp) => {
				this.navios = resp.data.navios;
				this.$set(this, 'data', resp.data);
			});

			this.$emit('setHeader', ['Dashboard', '']);
		},
	};
</script>
<style>
	#situacao-dos-contratos canvas,
	#contratos-por-regiao #chart {
		height: 400px !important;
	}
	/*	.no-data {
		text-align: center;
    	margin: 20px 0;

	}
	.no-data i {
		font-size: 100px;
	    color: #bdbdbd;
	}
	.no-data span {
		font-size: 22px;
	    font-weight: 100;
	    color: #cecece;

	}*/
</style>



// WEBPACK FOOTER //
// src/components/exames_dashboard/index.vue